export { default as TertiaryPanel } from "./TertiaryPanel"
